// アクションログパネル (= DDSIM-27 Pass 4): 画面左に試合の行動ログを表示。
//
// MatchSnapshot は log を持たないため client 側で組み立てた行動列を受け取る
// (= P1 の操作 + CPU ターンの粗い marker)。 flex-col-reverse で最新を上に出す。
// 厳密な CPU の手単位ログは engine-wasm `cpu_take_turn` が action 列を返す改修待ち。

export function LogPanel(props: { entries: string[] }): JSX.Element | null {
  const { entries } = props;
  if (entries.length === 0) return null;
  return (
    <div className="fixed left-4 top-20 z-40 w-44 rounded-lg border border-slate-700 bg-slate-900/90 p-2 text-slate-200 shadow-lg">
      <div className="mb-1 text-[10px] font-bold uppercase tracking-wide text-slate-400">
        Log
      </div>
      <ol className="flex max-h-[55vh] flex-col-reverse gap-0.5 overflow-y-auto text-[10px] leading-tight">
        {entries.map((entry, i) => (
          <li
            key={i}
            className="border-b border-slate-800 pb-0.5 text-slate-300"
          >
            {entry}
          </li>
        ))}
      </ol>
    </div>
  );
}
